import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { AgGridModule } from '@ag-grid-community/angular';
import { SharedModule } from '../shared/shared.module';
import { FilterModule } from '../filter/filter.module';

import {
  MatProgressSpinnerModule,
  MatFormFieldModule,
  MatInputModule,
  MatSelectModule,
  MatExpansionModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatButtonModule,
  MatSnackBarModule,
  MatIconModule
} from '@angular/material';

import {GridComponent} from './components/grid/grid.component';
import {GridContainerComponent} from './components/grid-container/grid-container.component';
import {BtnCellComponent} from './components/cell-components/btn-cell/btn-cell.component';
import {LinkCellComponent} from './components/cell-components/link-cell/link-cell.component';
import {ColHeaderCellComponent} from './components/cell-components/col-header-cell/col-header-cell.component';
import {SummarizeCellComponent} from './components/cell-components/summarize-cell/summarize-cell.component';



@NgModule({

  declarations: [
    GridContainerComponent,
    GridComponent,
    BtnCellComponent,
    LinkCellComponent,
    ColHeaderCellComponent,
    SummarizeCellComponent
  ],

  imports: [
    MatProgressSpinnerModule,
    CommonModule,
    FilterModule,
    HttpClientModule,
    AgGridModule.withComponents([BtnCellComponent, LinkCellComponent, ColHeaderCellComponent, SummarizeCellComponent]),
    MatProgressSpinnerModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatIconModule,
    MatSnackBarModule,
    MatFormFieldModule,
  ],

  entryComponents: [GridContainerComponent],

  exports: [GridContainerComponent, GridComponent],
})
export class GridModule { }
